<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <el-menu :default-active="idx" class="el-menu-demo" mode="horizontal">
                <el-menu-item index="1" @click="$router.push('witSite')">智慧工地</el-menu-item>
                <el-menu-item index="2" @click="$router.push('applySafety')">智慧安全</el-menu-item>
                <el-menu-item index="3" @click="$router.push('applyCartoon')">工程动画</el-menu-item>
            </el-menu>
        </div>
        <div class="box3">
            <div class="bo" v-for="item in dataList" :key="item.id" @click="donClick(item.id)">
                <img :src="item.img"  width="100%" height="100%">
                <div>
                    <span>{{item.title}}</span>
                </div>
            </div>
            <div style="clear:left"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductSafety",
        data(){
            return{
                idx: '1',
                dataList:[
                    {id:1,img:require('../../assets/images/apply/site/1.jpg'),title:'佛山万科金融中心广场'},
                    {id:2,img:require('../../assets/images/apply/site/2.jpg'),title:'长沙京武浪琴山三期'},
                    {id:3,img:require('../../assets/images/apply/site/3.jpg'),title:'东莞万科东江之星'},
                    {id:4,img:require('../../assets/images/apply/site/4.jpg'),title:'华邦国际中心'},
                    {id:5,img:require('../../assets/images/apply/site/5.jpg'),title:'前海冠泽金融中心项目'},
                    {id:6,img:require('../../assets/images/apply/site/6.jpg'),title:'南沙医院'},
                    {id:7,img:require('../../assets/images/apply/site/7.jpg'),title:'深湾汇云中心'},
                    {id:8,img:require('../../assets/images/apply/site/8.jpg'),title:'碧桂园'},
                    {id:9,img:require('../../assets/images/apply/site/9.jpg'),title:'武汉京东方'},
                    {id:10,img:require('../../assets/images/apply/site/10.jpg'),title:'深圳恒大中心'},
                    {id:11,img:require('../../assets/images/apply/site/11.jpg'),title:'深圳前海嘉里广场项目'},
                    {id:12,img:require('../../assets/images/apply/site/12.jpg'),title:'深圳紫元元大厦项目'}
                ]
            }
        },
        methods:{
            donClick(id){
                sessionStorage.setItem('applyCode',id);
                this.$router.push('applyDetail');
                document.documentElement.scrollTop=0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        height: 2.9rem;
        width: 100%;
        background: url("../../assets/images/apply/al.jpg");
        background-size: 100% 100%;
    }
    .box2{
        width: 6.24rem;
        margin: .34rem auto .6rem;
        text-align: center;
        a{
            text-decoration:none;
        }
        .el-menu-item{
            width:2.08rem;
            font-size: .2rem;
            height: .72rem;
            line-height: .72rem;
        }
        .el-menu--horizontal>.el-menu-item.is-active {
            border-bottom: 3px solid #E70F20;
            color: #E70F20;
        }
        .el-menu--horizontal>.el-menu-item {
            color:#000;
        }
    }
    .box3{
        width: 12rem;
        margin:0 auto;
        div.bo{
            position: relative;
            width:4rem;
            height:2.5rem;
            float: left;
            cursor:pointer;
            div{
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height: 100%;
                font-size: .2rem;
                color:#fff;
                text-align: center;
                line-height: 2.5rem;
                background: rgba(231,15,32,0.6);
                display: none;
                span{
                    position: relative;
                }
                span::before{
                    position: absolute;
                    content:"";
                    background: #fff;
                    width: 2px;
                    height: .14rem;
                    top:.05rem;
                    left:-.1rem;
                }
            }
        }
        div.bo:hover{
            div{
                display: block;
            }
        }
    }
</style>
